import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchHistoryData, updateHistoryData } from "../../../redux/actions/aboutUsActions";
import PageComponent from "../../../Components/PageComponent";
import { FaHistory } from "react-icons/fa";
import { LuTarget, LuUserCheck } from "react-icons/lu";
import ReactQuill from "react-quill";

function OurHistory() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data: historyData, loading } = useSelector((state) => state.aboutUs.history);

  const [id, setId] = useState(null);
  const [history, setHistory] = useState("");

  useEffect(() => {
    dispatch(fetchHistoryData());
  }, [dispatch]);

  useEffect(() => {
    if (historyData) {
      setId(historyData.id || null);
      setHistory(historyData.description || ""); // Fix key issue
    }
  }, [historyData]);

  const handleUpdate = (e) => {
    e.preventDefault();
    if (!id) {
      alert("ID is missing. Unable to update history.");
      return;
    }
    dispatch(updateHistoryData(id, history));
    alert("History updated successfully!"); // Show success message

  dispatch(fetchHistoryData());
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }], // Heading styles
      [{ font: [] }], // Font selection
      [{ list: "ordered" }, { list: "bullet" }], // Ordered (numbered) and unordered (bullet) lists
      ["bold", "italic", "underline"], // Font styles
      [{ align: [] }], // Alignment options
      ["clean"], // Clear formatting
    ],
  };
  
  const formats = [
    "font",
    "header",
    "list", // Include list format
    "bold",
    "italic",
    "underline",
    "align",
    
  ];

  return (
    <PageComponent>
      <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
        <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
          <Sidebar />
        </div>
        <div className="flex-1 p-6 ml-64">
          <div className="flex items-center space-x-2 text-3xl text-gray-500">
            <span>About Us</span>
            <span>/</span>
            <span className="text-black">Our History</span>
          </div>
           {/* Buttons */}
                  <div className="flex items-center mt-4 mb-5 space-x-4">
                    <button
                      className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                      onClick={() => navigate("/aboutus/vision")}
                    >
                      <LuTarget className="mr-2" />
                      Vision & Mission
                    </button>
                     <button
                        className="flex items-center px-4 py-2 text-white bg-[#92288C] rounded-lg shadow hover:bg-[#6C0B67]"
                        onClick={() => navigate("/aboutus/history")}
                      >
                        <FaHistory className="mr-2" />
                        Our History
                      </button>
                    <button className="flex items-center px-4 py-2 text-[#A8AAAE] rounded-lg shadow hover:bg-gray-100"
                    onClick={() => navigate("/aboutus/leadershipMessage")}>
                      <LuUserCheck className="mr-2" />
                      Leadership Messages
                    </button>
                  </div>
          <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <form onSubmit={handleUpdate}>
                <div className="space-y-4">
                  <div>
                    <label className="block mb-2 text-gray-700">Update History</label>
                    <ReactQuill
                      value={history}
                      onChange={setHistory}
                      theme="snow"
                      modules={modules}
                      formats={formats}
                      className="h-[180px]"
                      placeholder="Enter your history..."
                    />
                  </div>
                </div>
                <div className="flex justify-end mt-12 space-x-4">
                  <button
                    type="reset"
                    onClick={() => setHistory(historyData?.description || "")} // Fix reset
                    className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="px-4 py-2 text-white bg-[#92288C] rounded-md hover:bg-[#6C0B67]"
                  >
                    Update
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </PageComponent>
  );
}

export default OurHistory;
